import React from 'react';
import MainLayout from '../layouts/MainLayout';
import mahawarpdf from '../assets/pdf/inauguration-ceremony.pdf';
import personImage from '../assets/img/testimonials/new.png';
import personImage2 from '../assets/img/testimonials/new-2.png';

function InaugurationCeremony() {
    return (
        <MainLayout>
            <section id="inauguration" className="inauguration section light-background py-5">

                {/* Section Title */}
                <div className="container section-title text-center mb-5" data-aos="fade-up">
                    <h1 className="display-2 fw-bolder mb-4  text-uppercase ">
                        Inauguration Ceremony
                    </h1>
                    <div><span class="fs-5"><b>Mahawar Palace</b>, Near Pushpanjli Hospital, Colonel Ram Singh Chowk, Plot No. 1, Sector-4, Byepass Road, Rewari-123401, Haryana, India</span> <br></br><span className="description-title text-heritage-maroon fs-3">दिनांक: <b> 21 जून 2026</b> </span></div>
                </div>{/* End Section Title */}

                <div className="container" data-aos="fade-up" data-aos-delay="100">

                    <div className="row gy-4">
                        <div className="col-lg-6 ">
                            <div className="row gy-4">
                                <div class="card mb-3  p-4 rounded-4 shadow-sm border-gold h-100">

                                    <div className="col-lg-12">
                                        <div className="info-item d-flex flex-column flex-lg-row align-items-center bg-white" data-aos="fade-up" data-aos-delay="200">

                                            {/* Left Side Image */}
                                            <div className="col-lg-6 text-center mb-3 mb-lg-0">
                                                <img src={personImage} alt="Person Name" className="img-fluid rounded-4 shadow-sm" style={{ height: '400px', objectFit: 'cover' }} />
                                            </div>

                                            {/* Right Side Content */}
                                            <div className="col-lg-6 text-center text-lg-start ps-lg-4">
                                                <h2 className="fw-bold fs-4 text-heritage-maroon mb-2 text-center">मुख्य अतिथि<br /> <span class="fs-1"> श्री नवल किशोर गुप्ता जी</span>
                                                </h2>
                                                <h4 class="text-center">उपाध्यक्ष, मार्केट कमेटी, रेवाड़ी<br></br>
                                                    पूर्व प्रधान, महावर सभा (रजि.), रेवाड़ी</h4>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="col-lg-12 text-center py-5 ">
                                        <h3 className="fw-bold fs-5"></h3>
                                        <p className="mb-0" style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
                                            महावर समाज के एक सम्मानित एवं प्रेरणादायी व्यक्तित्व, आदरणीय श्री नवल किशोर गुप्ता जी समाज सेवा, समर्पण एवं नेतृत्व के पर्याय हैं। आपने महावर समाज के पूर्व प्रधान के रूप में सफलतापूर्वक अपनी सेवाएँ प्रदान की हैं तथा वर्तमान में मार्केटिंग कमेटी के वाइस प्रेसिडेंट के रूप में महत्वपूर्ण दायित्व निभा रहे हैं।
                                            समाज के विकास एवं उत्थान हेतु आपका योगदान सदैव अनुकरणीय रहा है। गौशाला विकास, मंदिर निर्माण, सामाजिक एवं धार्मिक आयोजनों सहित समाज के प्रत्येक महत्वपूर्ण कार्य में आपने तन, मन एवं धन से सहयोग प्रदान किया है। आपके सहयोग और मार्गदर्शन से अनेक सामाजिक कार्यों को नई दिशा एवं गति प्राप्त हुई है।
                                            आप केवल एक सफल सामाजिक नेतृत्वकर्ता ही नहीं, बल्कि समाज के अग्रणी भामाशाहों में से एक हैं। आपकी सादगी, विनम्रता एवं सभी के प्रति आत्मीय व्यवहार आपको विशेष पहचान प्रदान करता है।
                                            महावर समाज को आपके अनुभव, मार्गदर्शन एवं सेवा भावना पर सदैव गर्व रहेगा।
                                            महावर सभा (रजि.) रेवाड़ी परिवार की ओर से आपका हार्दिक स्वागत एवं अभिनंदन।</p>
                                    </div>
                                </div>
                                <div class="card mb-3  p-4 rounded-4 shadow-sm border-gold h-100">

                                    <div className="col-lg-12">
                                        <div className="info-item d-flex flex-column flex-lg-row align-items-center bg-white" data-aos="fade-up" data-aos-delay="200">

                                            {/* Left Side Image */}
                                            <div className="col-lg-6 text-center mb-3 mb-lg-0">
                                                <img src={personImage2} alt="Person Name" className="img-fluid rounded-4 shadow-sm" style={{ height: '400px', objectFit: 'cover' }} />
                                            </div>

                                            {/* Right Side Content */}
                                            <div className="col-lg-6 text-center text-lg-start ps-lg-4">
                                                <h2 className="fw-bold fs-4 text-heritage-maroon mb-2 text-center">समारोह अध्यक्ष <br /> <span class="fs-1"> श्री टी.सी. गुप्ता जी (IAS)
                                                </span>
                                                </h2>
                                                <h4 class="text-center">
                                                    पूर्व मुख्य आयुक्त, सेवा अधिकार आयोग, हरियाणा सरकार
                                                </h4>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="col-lg-12 text-center py-5 ">
                                        <h3 className="fw-bold fs-5"></h3>
                                        <p className="mb-0" style={{ textAlign: 'justify', textJustify: 'inter-word' }}>
                                            हरियाणा कैडर के वरिष्ठ IAS अधिकारी एवं महावर समाज के सम्मानित मार्गदर्शक, आदरणीय श्री टी.सी. गुप्ता जी प्रशासनिक दक्षता, ईमानदारी और जनसेवा के उत्कृष्ट प्रतीक हैं। आपने लगभग 34 वर्षों की गौरवपूर्ण प्रशासनिक सेवा के दौरान अनेक महत्वपूर्ण पदों पर कार्य करते हुए समाज एवं राष्ट्र के विकास में उल्लेखनीय योगदान दिया है।
                                            सेवानिवृत्ति के पश्चात भी आपकी सेवाएँ समाज को निरंतर प्राप्त होती रहीं। हरियाणा राइट टू सर्विस आयोग के मुख्य आयुक्त के रूप में आपने पारदर्शी, जवाबदेह एवं समयबद्ध सेवाओं को बढ़ावा देकर सुशासन की नई मिसाल स्थापित की। आपके अनुभव, नेतृत्व एवं दूरदर्शिता ने अनेक जनहितकारी कार्यों को नई दिशा प्रदान की।
                                            महावर समाज के लिए आपका योगदान विशेष रूप से प्रेरणादायी एवं अविस्मरणीय है। महावर पैलेस के स्वप्न को साकार करने में आपके मार्गदर्शन, सहयोग एवं विशेष प्रयासों की महत्वपूर्ण भूमिका रही है। भूमि उपलब्ध करवाने तथा विभिन्न प्रशासनिक प्रक्रियाओं को सरल एवं सुगम बनाने में आपका अमूल्य सहयोग समाज सदैव कृतज्ञता के साथ स्मरण करेगा।
                                            महावर सभा (रजि.) रेवाड़ी परिवार की ओर से समारोह अध्यक्ष आदरणीय श्री टी.सी. गुप्ता जी का हार्दिक स्वागत, अभिनंदन एवं वंदन।</p>
                                    </div>
                                </div>
                                {/* End Info Item */}



                            </div>
                        </div>

                        <div className="col-lg-6" data-aos="fade-up" data-aos-delay="500">
                            <div style={{ height: "100%", width: "100%" }}>
                                <embed src={mahawarpdf} type="application/pdf" width="100%" height="100%" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>{/* /Inauguration Section */}
        </MainLayout>
    );
}

export default InaugurationCeremony;